<template>
    <div v-if="getMailGroupMember.data">
        <group-header :page-name="groupName"></group-header>
        <div v-if="getMailGroupMember.data.group_members.length > 0">
            <group-input></group-input>
            <group-list v-show="show"></group-list>
        </div>
        <!-- 0件メッセージ -->
        <not-found-msg v-else></not-found-msg>
        <!-- グループ変更 -->
        <group-change></group-change>
    </div>
</template>

<script>
    import GroupHeader from 'pages/commons/header/Header'

    import GroupInput from './components/Input'
    import GroupList from './components/List'
    import GroupChange from './components/GroupChange'
    import NotFoundMsg from 'pages/commons/notFoundMsg/NotFoundMsg'
    
    import {mapGetters} from 'vuex'

    export default {
        components: {
            GroupHeader,
            GroupInput,
            GroupList,
            GroupChange,
            NotFoundMsg
        },
        created () {
            this.loadMailGroupMember()
        },
        destroyed () {
            this.$store.dispatch('resetMailGroupMember')
        },
        data () {
            return {
                show: true
            }
        },
        watch: {
            getMailGroupMemberLoadStatus (status) {
                if (status == 1) {
                    this.$store.dispatch('startProgress')
                }
                if (status == 2) {
                    this.$store.dispatch('doneProgress')
                }
                if (status == 3) {
                    this.$store.dispatch('doneProgress')
                }
            }
        },
        computed: {
            groupName () {
                if (this.$route.params.group == 'tech') {
                    return '技術者'
                }
                if (this.$route.params.group == 'company') {
                    return '法人'
                }
                return this.getMailGroupMember.data.group_nm
            },
            ...mapGetters(['getMailGroupMemberLoadStatus', 'getMailGroupMember'])
        },
        methods: {
            loadMailGroupMember () {
                this.$store.dispatch('loadMailGroupMember', {
                    type: this.$route.params.type,
                    group: this.$route.params.group
                })
            },
            showMemberList () {
                this.show = true
            },
            hideMemberList () {
                this.show = false
            },
        }

    }

</script>

<style lang='stylus' scoped>

</style>
